import api from "../api/api";

const submitComplaint = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/guest/complaint/submit",data,  
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}


const reopenComplaint = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/guest/complaint/reopen",data,  
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}

const selfCancelComplaint = (data) =>{
    return new Promise((resolve, reject)=>{
        api.post("/guest/complaint/self-cancel",data,  
            {
                headers: {
                    'Content-Type': 'multipart/form-data'
                },
            }
        ).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}

const getComplaintList = (customerPhone) =>{
    return new Promise((resolve, reject)=>{
        api.post("/guest/complaint/list",{customerPhone:customerPhone}).then( (res)=>{
            if(!res.data.error){
                resolve(res.data);
            } else {
                reject({
                    msg :"res.data.msg"
                })
            }
        }).catch( (error) => {
            reject({
                msg : "Something Went Wrog",
                error : error
            })
        })
    })
}


const getComplaintById = (gid) =>{
    return new Promise((resolve, reject)=>{
        api.get("/guest/complaint/id/"+gid).then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}



const getCaptchaImage = (gid) =>{
    return new Promise((resolve, reject)=>{
        api.get("/captcha").then( (res)=>{
            resolve(res.data)
        }).catch( (error) => {
            reject(error)
        })
    });
}


const portalServices = {
    getComplaintList,
    getComplaintById,
    submitComplaint,
    reopenComplaint,
    selfCancelComplaint,
    getCaptchaImage
}
export default portalServices;